/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { useAppContext } from '../../App'
import { getBrand } from '../../twd/all';

const state = {}

export default () => {
    const { ajax, Status } = useAppContext()

    const msg = state.messages
    const initStatus = !msg ? Status.LOADING : Status.LOADED

    const [status, setStatus] = React.useState(initStatus)
    const [messages, setMessages] = React.useState(msg || [])
    const updateMessages = (a) => {
        state.messages = a
        setMessages(a)
    }

    React.useEffect(() => {(async () => {
        if (status!==Status.LOADING) return
        try {
            let {data} = ajax({
                url:'/esb/administration/helpMessageCenterTab/getMessageCenterByBrandIdentifier',
                method: 'GET',
                params: {
                    brandname:getBrand(),
                    identifier:'overview'
                }
            })
            let a = (((await data)[0] || {}).messageCenterDetails || [])
                .sort( (a,b) => a.seq - b.seq)
            updateMessages(a)

            setStatus(Status.LOADED)
        } catch(e) {
            setStatus(Status.FAILED_TO_LOAD)
        }

    })()}, [status])

    const onDismiss = (messageId) => {
        let a = messages.filter((m) => m.messageId !== messageId)
        updateMessages(a)
    }

    return { status, Status, messages, onDismiss }
}
